export default __webpack_public_path__ + "static/media/fantastic-tour-pic.31ff93bd.jpg";